import { buildModelManager } from "../builder.js";
const DefaultAnalyticsConfigurationSelection = {
  __typename: true,
  id: true,
  connected: true,
  connectionMethod: true,
  createdAt: true,
  customDimensions: true,
  eventFilters: true,
  ga4ApiSecret: true,
  ga4MeasurementId: true,
  ga4PropertyId: true,
  lastTestEvent: true,
  shopId: true,
  testEventCount: true,
  updatedAt: true
};
const modelApiIdentifier = "analytics_configuration";
const pluralModelApiIdentifier = "analytics_configurations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByShop",
    findByField: "shopId",
    findByVariableName: "shopId",
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByShop",
    findByField: "shopId",
    findByVariableName: "shopId",
    modelApiIdentifier,
    defaultSelection: DefaultAnalyticsConfigurationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAnalyticsConfiguration",
    operationReturnType: "CreateAnalyticsConfiguration",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      analytics_configuration: { required: false, type: "CreateAnalyticsConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAnalyticsConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAnalyticsConfigurations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateAnalyticsConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAnalyticsConfigurationSelection
  },
  {
    type: "action",
    operationName: "updateAnalyticsConfiguration",
    operationReturnType: "UpdateAnalyticsConfiguration",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      analytics_configuration: { required: false, type: "UpdateAnalyticsConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAnalyticsConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAnalyticsConfigurations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateAnalyticsConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAnalyticsConfigurationSelection
  },
  {
    type: "action",
    operationName: "deleteAnalyticsConfiguration",
    operationReturnType: "DeleteAnalyticsConfiguration",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAnalyticsConfigurations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAnalyticsConfiguration",
    operationReturnType: "UpsertAnalyticsConfiguration",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      analytics_configuration: { required: false, type: "UpsertAnalyticsConfigurationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAnalyticsConfigurationResult": { hasReturnType: false },
      "... on UpdateAnalyticsConfigurationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAnalyticsConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAnalyticsConfigurations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertAnalyticsConfigurationsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAnalyticsConfigurationSelection
  }
];
const AnalyticsConfigurationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAnalyticsConfigurationSelection,
  operations
);
export {
  AnalyticsConfigurationManager,
  DefaultAnalyticsConfigurationSelection
};
//# sourceMappingURL=AnalyticsConfiguration.js.map
